import React from 'react'

import { UploadManagerStateContext } from './UploadManagerContext'

export function useUpload(mediaId: string) {
  const state = React.useContext(UploadManagerStateContext)
  return state?.uploads.find(upl => upl.mediaId === mediaId)
}
